import { DollarOutlined } from '@ant-design/icons';
import { RentalPropertyDetail } from '@hooks/RentalProperty';
import SNS from '@pages/Explore/components/RPModal/components/SNS';
import { Space, Typography } from 'antd';
import './style.less';

type RPContentProps = {
  data: RentalPropertyDetail;
};

const RPContent: React.FC<RPContentProps> = ({ data }) => {
  return (
    <Space direction="vertical" className="rp-content">
      <Typography.Text type="secondary">{data.description}</Typography.Text>
      <Space>
        <DollarOutlined />
        <Typography.Text>{data.bookingPrice}</Typography.Text>
      </Space>
      <Space>
        {data.sns.map((sns) => (
          <SNS data={sns} key={sns.type} />
        ))}
      </Space>
    </Space>
  );
};

export default RPContent;
